/**
 * Created by sivanh on 14/06/18.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var ScheduleUtilities = require("utils/ScheduleUtilities");
    var ShiftsCollection = require("collections/entities/scheduling/ShiftsCollection");

    var NAME ="ScheduleEventModel";

    var KEYS = {
        ID: "id",
        START_DATE: "startDate",
        END_DATE: "endDate",
        TYPE: "type",
        SHIFTS: "shifts"
    };

    var ScheduleEventModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        ScheduleEventModel = BaseModel.extend({
            KEYS: KEYS,
            name: NAME,
            defaults:{
                id: "",
                startDate: "",
                endDate: "",
                type: "",
                shifts: []
            },
            validation: {
                "shifts.0": [
                    {
                        fn: function() {
                            // validate hierarchy the collection
                            var shiftsCollectionErrors = this.shiftsCollection.validate();
                            if (!_.isEmpty(shiftsCollectionErrors)) {
                                return "LEFramework.entities.schedule.errors.generalError.internalError";
                            }
                        }
                    }
                ]
            },

            initialize: function (options) {
                this.shiftsCollection = new ShiftsCollection(this.getShifts());
                BaseModel.prototype.initialize.call(this, options);
            },

            addShiftItem: function (attr){
                attr = attr || {};
                var Model = this.shiftsCollection.model;
                this.shiftsCollection.add(new Model(attr));
            },

            removeShiftItem: function(model){
                this.shiftsCollection.remove(model);
            },

            getType: function () {
                return this.get(KEYS.TYPE);
            },

            setType: function (type) {
                this.set(KEYS.TYPE, type);

                if (type !== ScheduleUtilities.EVENT_TYPES.CUSTOM){
                    this.shiftsCollection.reset();
                }
                else {
                    this.addShiftItem();
                }
            },

            getShifts: function () {
                return this.get(KEYS.SHIFTS);
            },

            setShifts: function (shifts) {
                this.set(KEYS.SHIFTS, shifts);
            },

            getShiftsCollection: function () {
                return this.shiftsCollection;
            }

        });

    });


    ScheduleEventModel.NAME = NAME;
    ScheduleEventModel.KEYS = KEYS;

    return ScheduleEventModel;
});
